<script>
  import { onDestroy, onMount } from "svelte";
  import Header from "./header/Header.svelte";
  import Footer from "./footer/Footer.svelte";
  import { t, router, settings, navigateTo } from "../../core";
  import type { IPageData } from "../../core/types";
  import Popup from "../elements/Popup.svelte";
  import { get } from "svelte/store";
  import CaseChangedPopup from "../blocks/popups/case-changed/CaseChangedPopup.svelte";
  import { parseQueryParams, queryParamsToString, redirectTo } from "../../core/general/routing";
  import { QuestionnaireBlockType, tryToGetUser, userInfo, UserInformationType } from "./header/user/user-store";
  import { expiredCaseQueryParam, loginRetryCountQueryParam } from "../../shared/constants/general";
  import QuestionnairePopup from "../blocks/popups/questionaire/QuestionnairePopup.svelte";
  import axios from "axios";

  export let data: IPageData;
  
  const layoutId = "layout";

  let isShowQuestionarePopup: boolean;
  let questionnaire: QuestionnaireBlockType;

  let expiredCaseNumber: string = '';
  $: isShowCaseChangedPopup = !!expiredCaseNumber;
  let currentCaseNumber: string = '';

  userInfo.subscribe((user: UserInformationType) => {
    currentCaseNumber = user?.cases.find(c => c.isCurrent)?.caseNumber ?? '';
    isShowQuestionarePopup = user?.questionnaireBlock?.showPopUp && !user.isImpersonationMode;
    questionnaire = user?.questionnaireBlock;
  })

  onMount(() => {
    tryToGetUser();

    const queryParams = parseQueryParams(get(router));
    delete queryParams[loginRetryCountQueryParam];
    const queryParamsStr = queryParamsToString(queryParams) ? `?${queryParamsToString(queryParams)}` : '';
    redirectTo(window.location.pathname + queryParamsStr + window.location.hash);
  })

  onDestroy(
    router.subscribe((path) => {
      const queryParams = parseQueryParams(path);
      expiredCaseNumber = queryParams[expiredCaseQueryParam];

      document.body.focus();
    })
  );

  function closeCaseChangedPopup() {
    expiredCaseNumber = '';
    const queryParams = parseQueryParams(get(router));
    delete queryParams[expiredCaseQueryParam];
    const queryParamsStr = queryParamsToString(queryParams) ? `?${queryParamsToString(queryParams)}` : '';
    redirectTo(window.location.pathname + queryParamsStr + window.location.hash);
  }

  function closeQustionairePopup() {
    axios.post('/api/Questionnaire/popUpChecked')
      .then(res => {
        tryToGetUser();
      })
  }
</script>

<svelte:head>
  <title>
    {data?.title || data?.name}
    {settings?.pageTitleSeparator || ""}
    {settings?.siteTitle || ""}
  </title>

  <meta name="description" content={data?.title || ""} />
</svelte:head>

<main class="page-wrapper">
  <a class="btn skip-main" href="#{layoutId}">
    {t("general.skiptomain.button")}
  </a>

  <Header />

  <div class="page-content" role="main" tabindex="-1" id={layoutId}>
    <slot />
  </div>
</main>

<Footer />

<Popup isShow={isShowCaseChangedPopup} withoutClose={true} on:close={closeCaseChangedPopup}>
  <CaseChangedPopup expiredCaseNumber={expiredCaseNumber} newCaseNumber={currentCaseNumber} on:close={closeCaseChangedPopup} />
</Popup>

<Popup isShow={isShowQuestionarePopup} withoutClose={true} on:close={closeQustionairePopup}>
  <QuestionnairePopup 
    {questionnaire} 
    on:close={closeQustionairePopup}
  />
</Popup>

<style lang="scss">
  .page-content {
    padding: 30px 0;

    @include md {
      padding: 60px 0;
    }
  }

  [role="main"]:focus {
    outline: none;
  }

  .skip-main {
    position: absolute;
    top: auto;
  }

  .skip-main:focus,
  .skip-main:active {
    left: 20px;
    margin: 10px auto;
    z-index: 999;
  }

  .skip-main:not(:focus):not(:active) {
    left: -999px;
    width: 1px;
    height: 1px;
    overflow: hidden;
    z-index: -999;
  }
</style>
